import { render, staticRenderFns } from "./VacancyEmptyCard.vue?vue&type=template&id=5c88a3be"
import script from "./VacancyEmptyCard.vue?vue&type=script&lang=js"
export * from "./VacancyEmptyCard.vue?vue&type=script&lang=js"
import style0 from "./VacancyEmptyCard.vue?vue&type=style&index=0&id=5c88a3be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports